import { render, staticRenderFns } from "./NotificationTimeSelector.vue?vue&type=template&id=52649c66&scoped=true"
import script from "./NotificationTimeSelector.vue?vue&type=script&lang=js"
export * from "./NotificationTimeSelector.vue?vue&type=script&lang=js"
import style0 from "./NotificationTimeSelector.vue?vue&type=style&index=0&id=52649c66&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52649c66",
  null
  
)

export default component.exports